import { useCallback, useEffect, useMemo, useState } from "react";
import { BRANDING_UPDATED_EVENT } from "../../../Pages/Public/partnerAppTheme";
import { loadItem } from "../../../Utils";
import { isPartnerBrandOptions } from "../../../Hooks/WhiteLabel";
import { ValutWordmarkLogo } from "./ValutWordmarkLogo";

const readLogoOptions = () => loadItem("Options") || {};

const withBrandingAssetCacheBust = (url) => {
  const trimmed = String(url || "").trim();
  if (!trimmed || !trimmed.startsWith("/branding/")) {
    return trimmed;
  }
  if (/[?&]v=/.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}${trimmed.includes("?") ? "&" : "?"}v=20260831`;
};

const pickLogoSrc = (options, { preferWhite }) => {
  const logoDefault = withBrandingAssetCacheBust(options.logo_default);
  const logoWhite = withBrandingAssetCacheBust(options.logo_white);
  if (preferWhite) {
    return logoWhite || logoDefault;
  }
  return logoDefault || logoWhite;
};
export const CompanyLogo = ({
  width,
  height = undefined,
  isWhiteLogo = false,
  forceValut = false,
  onDark = false,
  variant = "dark",
}) => {
  const [options, setOptions] = useState(readLogoOptions);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    const sync = () => {
      setOptions(readLogoOptions());
      setImageFailed(false);
    };

    sync();
    window.addEventListener(BRANDING_UPDATED_EVENT, sync);
    return () => window.removeEventListener(BRANDING_UPDATED_EVENT, sync);
  }, []);

  const preferWhite = isWhiteLogo || onDark;
  const src = useMemo(
    () => pickLogoSrc(options, { preferWhite }),
    [options, preferWhite],
  );
  const alt = String(options.branch_name || options.title || "Logo").trim();
  const isPartner = isPartnerBrandOptions(options);

  const showValutFallback =
    forceValut || !src || imageFailed || (!isPartner && !src);

  if (showValutFallback) {
    return (
      <ValutWordmarkLogo
        width={width || 210}
        height={height}
        onDark={onDark}
        variant={variant}
      />
    );
  }

  const resolvedWidth = width || 210;
  const resolvedHeight = height || Math.round(resolvedWidth / (123 / 26));

  const handleError = useCallback(() => {
    setImageFailed(true);
  }, []);

  return (
    <img
      src={src}
      alt={alt}
      width={resolvedWidth}
      height={resolvedHeight}
      onError={handleError}
      className="partner-brand-logo"
      style={{
        display: "block",
        width: resolvedWidth,
        maxWidth: "100%",
        height: "auto",
        maxHeight: resolvedHeight,
        objectFit: "contain",
        objectPosition: "left center",
        filter: "none",
      }}
    />
  );
};

CompanyLogo.propTypes = {};
